(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    (function () {
    function getGalleryIndex(gallery) {
      var w = gallery.clientWidth;
      return w > 0 ? Math.round(gallery.scrollLeft / w) : 0;
    }

    function navigate(zoomEl, index) {
      var gal = zoomEl.querySelector('.dialog-zoomed-gallery');
      if (gal) gal.scrollTo({ left: index * gal.clientWidth, behavior: 'smooth' });
    }

    function setupDialog(zoomEl) {
      if (zoomEl._zoomSetup) return;
      zoomEl._zoomSetup = true;

      var dialog = zoomEl.querySelector('dialog');
      var gallery = zoomEl.querySelector('.dialog-zoomed-gallery');
      if (!dialog || !gallery) return;

      /* Redirect gallery scroll → dialog so zoom-dialog.js#handleScroll fires */
      gallery.addEventListener('scroll', function () {
        dialog.dispatchEvent(new Event('scroll'));
      }, { passive: true });

      /* Click outside image (on dialog backdrop / empty area) → close */
      dialog.addEventListener('click', function (e) {
        var target = e.target;
        /* Close when clicking the dialog itself (backdrop area) or directly on the gallery <ul> */
        if (target === dialog || target === gallery) {
          if (typeof zoomEl.close === 'function') {
            zoomEl.close();
          } else {
            dialog.close();
          }
        }
      });

      /* Inject prev / next arrows */
      var count = gallery.querySelectorAll('li').length;
      if (count < 2) return;

      /* Remove any previously injected arrows (e.g. after variant change) */
      dialog.querySelectorAll('.zoom-nav-btn').forEach(function (el) { el.remove(); });

      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'zoom-nav-btn zoom-nav-prev';
      prev.setAttribute('aria-label', 'Previous image');
      prev.innerHTML = '&#8249;';

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'zoom-nav-btn zoom-nav-next';
      next.setAttribute('aria-label', 'Next image');
      next.innerHTML = '&#8250;';

      prev.addEventListener('click', function (e) {
        e.stopPropagation();
        var i = getGalleryIndex(gallery);
        navigate(zoomEl, i > 0 ? i - 1 : count - 1);
      });

      next.addEventListener('click', function (e) {
        e.stopPropagation();
        var i = getGalleryIndex(gallery);
        navigate(zoomEl, i < count - 1 ? i + 1 : 0);
      });

      dialog.appendChild(prev);
      dialog.appendChild(next);
    }

    function initAll() {
      document.querySelectorAll('zoom-dialog').forEach(setupDialog);
    }

    document.addEventListener('DOMContentLoaded', initAll);

    /* Re-initialize when media-gallery is replaced after a variant/color change */
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.tagName === 'MEDIA-GALLERY') {
            node.querySelectorAll('zoom-dialog').forEach(function (zd) {
              zd._zoomSetup = false;
              setupDialog(zd);
            });
          }
          if (node.tagName === 'ZOOM-DIALOG') {
            node._zoomSetup = false;
            setupDialog(node);
          }
        });
      });
    });

    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  })();

  /* Cursor-following zoom: update transform-origin to mouse position */
  (function () {
    function attachHoverZoom(gallery) {
      gallery.querySelectorAll('.product-media-container--zoomable').forEach(function (container) {
        if (container._hoverZoom) return;
        container._hoverZoom = true;
        container.addEventListener('mousemove', function (e) {
          var rect = container.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width * 100).toFixed(1);
          var y = ((e.clientY - rect.top) / rect.height * 100).toFixed(1);
          var img = container.querySelector('.product-media__image');
          if (img) img.style.transformOrigin = x + '% ' + y + '%';
        });
        container.addEventListener('mouseleave', function (e) {
          var parentGallery = container.closest('media-gallery');
          if (parentGallery && e.relatedTarget && parentGallery.contains(e.relatedTarget)) return;
          var img = container.querySelector('.product-media__image');
          if (img) img.style.transformOrigin = 'center center';
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('media-gallery').forEach(attachHoverZoom);
    });

    var zoomObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node instanceof Element && node.tagName === 'MEDIA-GALLERY') attachHoverZoom(node);
        });
      });
    });
    document.addEventListener('DOMContentLoaded', function () {
      zoomObserver.observe(document.body, { childList: true, subtree: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    var SIZE_ORDER = [
      'XXXXS','XXXS','XXS','XS','XS/S','S','S/M','M','M/L','L','L/XL','XL',
      '2XL','XXL','3XL','XXXL','4XL','XXXXL','5XL','6XL'
    ];
    var _busy = false;

    function hideUnavailableButtons() {
      document.querySelectorAll('fieldset.variant-option--buttons:not(.variant-option--swatches)').forEach(function (fs) {
        fs.querySelectorAll('label').forEach(function (label) {
          var input = label.querySelector('input[type="radio"]');
          if (!input) return;
          label.style.display = input.dataset.optionAvailable === 'false' ? 'none' : '';
        });
      });
    }

    function processDropdown(select) {
      var selectedUnavail = false;
      Array.from(select.options).forEach(function (opt) {
        if (opt.dataset.optionAvailable === 'false') {
          opt.hidden = true;
          if (opt.selected) selectedUnavail = true;
        } else {
          opt.hidden = false;
        }
      });
      if (selectedUnavail) {
        var first = Array.from(select.options).find(function (o) {
          return o.dataset.optionAvailable === 'true';
        });
        if (first) {
          select.value = first.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    function sortSelect(select) {
      var opts = Array.from(select.options);
      if (opts.length < 2) return;
      var isNumeric = opts.every(function (o) { return o.value.trim() !== '' && !isNaN(parseFloat(o.value)); });
      var sorted = opts.slice().sort(function (a, b) {
        if (isNumeric) return parseFloat(a.value) - parseFloat(b.value);
        var ai = SIZE_ORDER.indexOf(a.value.trim().toUpperCase());
        var bi = SIZE_ORDER.indexOf(b.value.trim().toUpperCase());
        if (ai === -1 && bi === -1) return a.value.localeCompare(b.value);
        if (ai === -1) return 1;
        if (bi === -1) return -1;
        return ai - bi;
      });
      var changed = sorted.some(function (o, i) { return opts[i] !== o; });
      if (changed) sorted.forEach(function (o) { select.appendChild(o); });
    }

    function processAll() {
      if (_busy) return;
      _busy = true;
      try {
        hideUnavailableButtons();
        document.querySelectorAll('.variant-option--dropdowns select').forEach(function (s) {
          processDropdown(s);
          sortSelect(s);
        });
      } finally {
        _busy = false;
      }
    }

    function init() {
      processAll();
      /* variant:update fires after Dawn's morph completes — run synchronously so there is no visible flash */
      document.addEventListener('variant:update', processAll);
      /* MutationObserver as fallback — deferred one tick to avoid running mid-morph */
      document.querySelectorAll('variant-picker').forEach(function (picker) {
        new MutationObserver(function () { setTimeout(processAll, 0); }).observe(picker, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-option-available']
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
